const CAUTION = 'caution';
const CRITICAL = 'critical';
const INFORMATION = 'information';
const POSITIVE = 'positive';
export const SIGNAL_VARIANTS = { CAUTION, CRITICAL, INFORMATION, POSITIVE };
